import { render, staticRenderFns } from "./CommonFeatures.vue?vue&type=template&id=5ec9d30c&scoped=true"
import script from "./CommonFeatures.vue?vue&type=script&lang=ts"
export * from "./CommonFeatures.vue?vue&type=script&lang=ts"
import style0 from "./CommonFeatures.vue?vue&type=style&index=0&id=5ec9d30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec9d30c",
  null
  
)

export default component.exports